import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  LangChangeEvent,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {
  ChartAllModule,
  IAccLoadedEventArgs,
  AccumulationChartAllModule,
} from '@syncfusion/ej2-angular-charts';
import { Browser } from '@syncfusion/ej2-base';

@Component({
  selector: 'app-pie-legend',
  templateUrl: 'pie-legend.component.html',
  styleUrls: ['pie-legend.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ChartAllModule, AccumulationChartAllModule, TranslateModule],
})
export class PieLegendComponent implements OnInit {
  public data: Object[] = [];
  private _progression: any = null;

  @Input() set progressionData(val: any) {
    this._progression = val;
    if (val) this.loadChartData();
  }

  ngOnInit() {
    this.loadChartData();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadChartData();
    });
  }

  public colorPalettes: string[] = [
    '#696cff',
    '#9c9fff',
    '#d50b3e',
    '#2dca72',
    '#faaf00',
  ];
  //Initializing Legend
  public legendSettings: Object = {
    visible: false,
    toggleVisibility: false,
    position: 'Bottom',
    maximumColumns: Browser.isDevice ? 2 : 3,
    fixedWidth: true,
  };

  public innerRadius: string = window.innerWidth <= 768 ? '80%' : '40%';
  public startAngle: number = 70;
  public radius: string = Browser.isDevice ? '80%' : '85%';
  //Initializing Datalabel
  public dataLabel: Object = {
    name: 'text',
    visible: true,
    font: {
      fontWeight: '400',
      color: '#ffffff',
    },
  };

  // custom code start
  public load(args: IAccLoadedEventArgs): void {
    const theme = 'Material';
    args.chart.theme = theme as any;
  }
  public tooltip: Object = {
    enable: true,
    format: '<b>${point.x}</b> : <b>${point.y}%</b>',
    header: '',
    enableHighlight: true,
  };

  public onPointRender(args: any): void {
    // Alternate styles: even index gets border, odd does not
    if (args.point.index % 2 === 0) {
      args.border = { color: 'var(--chart-border)', width: 12 };
    } else {
      args.border = { color: 'transparent', width: 4 };
    }

    // Optionally override fill from your data object
    if (args.point?.fill) {
      args.fill = args.point.fill;
    }
  }

  constructor(private translate: TranslateService) {}

  loadChartData() {
    if (this._progression) {
      this.translate
        .get(['DASHBOARD.PASSED', 'DASHBOARD.FAILED', 'DASHBOARD.UNANSWERED'])
        .subscribe((t) => {
          const passed = this._progression.totalTestsPassed ?? 0;
          const failed = this._progression.totalTestsFailed ?? 0;
          const total  = this._progression.totalTestsTaken ?? (passed + failed);
          const other  = Math.max(0, total - passed - failed);
          this.data = [
            { x: t['DASHBOARD.PASSED'],    y: passed, r: '120',   text: passed.toString(),  fill: '#22c55e' },
            { x: t['DASHBOARD.FAILED'],    y: failed, r: '137.5', text: failed.toString(),  fill: '#ef4444' },
            ...(other > 0 ? [{ x: t['DASHBOARD.UNANSWERED'], y: other, r: '124.6', text: other.toString(), fill: '#faaf00' }] : []),
          ];
        });
      return;
    }

    this.translate
      .get([
        'CHART.MY_SKILLS',
        'CHART.MY_HOMEWORK',
        'CHART.DISCIPLINE',
        'CHART.EXAMS',
        'CHART.SLEEP',
      ])
      .subscribe((t) => {
        this.data = [
          { x: t['CHART.MY_SKILLS'],   y: 50, r: '120',   text: t['CHART.MY_SKILLS'],   fill: '#56d990' },
          { x: t['CHART.MY_HOMEWORK'], y: 80, r: '137.5', text: t['CHART.MY_HOMEWORK'], fill: '#9c9fff' },
          { x: t['CHART.DISCIPLINE'],  y: 35, r: '124.6', text: t['CHART.DISCIPLINE'],  fill: '#d50b3e' },
          { x: t['CHART.EXAMS'],       y: 30, r: '130.8', text: t['CHART.EXAMS'],       fill: '#2dca72' },
          { x: t['CHART.SLEEP'],       y: 30, r: '135.5', text: t['CHART.SLEEP'],       fill: '#faaf00' },
        ];
      });
  }
}
